import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Pagination from './Pagination';
var DefaultValue = {
  defaultCurrent: 1,
  pageSize: 10,
  total: 0
};

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(_default, _PureComponent);

  var _super = _createSuper2(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props); // @ts-ignore

    _this.state = {
      current: props.current || props.defaultCurrent,
      pageSize: props.pageSize
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.current !== this.props.current || prevProps.pageSize !== this.props.pageSize) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          current: this.props.current,
          pageSize: this.props.pageSize
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(current) {
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.pageSize;
      var sizeChange = pageSize !== this.state.pageSize;
      this.setState({
        current: current,
        pageSize: pageSize
      });

      if (this.props.onChange) {
        this.props.onChange(current, pageSize, sizeChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var current = this.props.current || this.state.current;
      if (this.props.total < 0) return null;
      return (
        /*#__PURE__*/
        React.createElement(Pagination, Object.assign({}, this.props, {
          current: current,
          pageSize: this.state.pageSize,
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return _default;
}(PureComponent);

_default.displayName = 'ShineoutPagination';
_default.defaultProps = DefaultValue;
export { _default as default };